import style from './TickerDetail.module.css';
import NumberFormatter from "../libs/NumberFormatter";

export default function TickerDetail(
    props: {
        symbol: string,
        currentTicker: {name: string, value: number, volatility: number},
        initialTicker: {name: string, value: number, volatility: number}
    }
) {

    const changeAmount = props.currentTicker.value - props.initialTicker.value;
    const changePercent = changeAmount / props.initialTicker.value * 100;

    return (
        <div className={`px-4 py-4 bg-white/50 z-10 absolute top-0 left-0 h-40
        border-l-8 ${changePercent > 0 ? "border-green-500/80" : "border-red-500/80"}`}>
            <div className={`leading-4 ${style.tickerSymbol}`}>{props.symbol}</div>
            <div className={style.tickerName}>{props.currentTicker.name}</div>
            <div className={`text-4xl ${style.currentPrice}`}>
                {NumberFormatter.toNumber(props.currentTicker.value, 2)}
                <span className={`text-xs pl-0.5 ${style.currentPriceCurrency}`}>USD</span>
            </div>
            <div className="text-sm flex items-center">
                <span className="pr-2">{NumberFormatter.toNumber(changeAmount, 2)}</span>
                <span>{NumberFormatter.toNumber(changePercent, 2)}%</span>
                <svg
                    id="triangle"
                    className={`h-3 w-3 ml-1 flex-no-shrink fill-current
                    ${changePercent > 0 ? "text-green-500/80" : "text-red-500/80"}`}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    transform={changePercent > 0 ? "" : "rotate(-180 0 0)"}
                >
                    <polygon points="50 15, 100 100, 0 100"  />
                </svg>
            </div>
        </div>
    );

}